// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rentterms.CreateRentTermsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateRentTermsWebApiRequestDto, CreateRentTermsWebApiResponseDto } from '../..';

export const CreateRentTermsWebApiHandler_createRentTerms_Path = '/api/web/v1/rentTerms/createRentTerms';

/**
 * Create rent terms
 */
export const CreateRentTermsWebApiHandler_createRentTerms = (
  postData: CreateRentTermsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateRentTermsWebApiRequestDto, CreateRentTermsWebApiResponseDto>(
    {
      endpoint: CreateRentTermsWebApiHandler_createRentTerms_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
